import React, { useState, useEffect } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

import BankIDlogo from '../../assets/images/bankid.png';

export const BankID = (props) => {
	const { translate } = props;

	const [QRImage, setQRImage] = useState(null);
	const [autoStartUrl, setAutoStartUrl] = useState(null);
	const [session_id, setSessionId] = useState(null);
	const [status, setStatus] = useState(null);

	let interval = null;

	useEffect(() => {
		const startSession = async () => {
			const data = await props.createSessionAction();

			console.log('data', data);

      if (data) {
        setQRImage('data:image/svg+xml;base64,' + data.QRCode);
        setAutoStartUrl('https://app.bankid.com/?autostarttoken=' + data.autoStartToken + '&redirect=');
        setStatus(data.status);
        setSessionId(data.sessionId);
      }

			return;
		};

		startSession().catch(console.log('oi'));
	}, []);

	useEffect(() => {
		interval = setInterval(async () => {
			if (session_id) {
				const data = await props.action();

				if (data.status === 'failed') {
					clearInterval(interval);
					setQRImage(null);
					setStatus('failed');
					setAutoStartUrl(null);
				} else {
					setQRImage('data:image/svg+xml;base64,' + data.QRCode);
					setAutoStartUrl('https://app.bankid.com/?autostarttoken=' + data.autoStartToken + '&redirect=');
					setSessionId(data.sessionId);
					setStatus(data.status);
				}
				console.log('Interval running');
			} else {
				clearInterval(interval);
			}
		}, 3000);

		// Cleanup on unmount
		return () => clearInterval(interval);
	}, [session_id]);

	return (
		<React.Fragment>
			{QRImage !== null ? <img className="generic-square-edges-image" src={QRImage} /> : <img src={BankIDlogo} height="70" alt="BankID logo" />}
		</React.Fragment>
	);
};

const mapStateToProps = (state) => ({
	translate: getTranslate(state.localize),
	settings: state.settings,
	config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
	createSessionAction: () => {},
	action: () => {},
});

export default connect(mapStateToProps, mapDispatchToProps)(BankID);
